import { render, staticRenderFns } from "./mostReservations.vue?vue&type=template&id=f4daeb96&"
import script from "./mostReservations.vue?vue&type=script&lang=js&"
export * from "./mostReservations.vue?vue&type=script&lang=js&"
import style0 from "./mostReservations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports